import React, { useEffect, useRef, useState } from "react";
import MaskedInput from "react-text-mask";
import "../components/NavMenu.css";
import axios from "axios";
import CKYCHome from "../CKYCModule/CKYCHome";
import { FaRegCircle } from "react-icons/fa";
import { CentralCall } from "./CommonJS";
import { CommaSeprator } from "./Utilities";
import PropHead from "./ChildComponents/PropHead";
import { baseUrl } from "../index";
import CustomDatePicker from "./CustomDate";
import { NewDateToDDMMYYYY, dateInDDMMYYYY, dateInNewDDMMYYYY, dateInYYYYMMDD } from "./ChildComponents/utils";
import { useHistory } from 'react-router-dom';
const IndemnityProposal = (props) => {
    const [specializationList, setSpecializationList] = useState();
    const [qualificationMaster, setQualificationMaster] = useState();
    const [DocTypeList, setDocTypeList] = useState("Make Payment");
    const [KYCDetails, setKYCDetails] = useState();
    const [PrevReq, setPrevReq] = useState();
    const [isKYCCalled, setIsKYCCalled] = useState();
    const [ProposalBTNValue, setProposalBTNValue] = useState("Make Payment");
    const [error, setError] = useState({});
    const [dob, setDob] = useState(null);
    const [cityState, setCityState] = useState({});
    const [formDetails, setFormDetails] = useState({
        Gender: "M",
        MobileNo: "",
        Email: "",
        InsurerID: "",
        EnquiryNo: "",
        ProposerName: "",
        DOB: "",
        Qualification: "",
        Specialization: "",
        PAN: "",
        Address1: "",
        Address2: "",
        StateCode: 0,
        CityCode: 0,
        ProposerAadhar: "",
        OccupationID: "",
        Experience: "",
        YearOfRegistration: "",
        LicenseObtainedYear: "",
        PinCode: "",
        CityAndState: "",
    });
    const history = useHistory();
    const today = new Date();
    const maxDate = new Date(
        today.getFullYear() - 18,
        today.getMonth(),
        today.getDate()
    );

    const minDate = new Date(
        today.getFullYear() - 100,
        today.getMonth(),
        today.getDate()
    );
    useEffect(() => {
        if (!dob) setDob(maxDate);
    }, []);
    console.log("Selected Date:", dob);
    console.log("Selected maxDate Date:", maxDate);
    const BindQualification = async () => {
        const EducationModel = {
            InsurerID: 126,
            MasterType: "Education",
            MasterCode: "doctor"
        };
        const { status, data } = await CentralCall("BindMaster_PI", EducationModel);
        if (status === 200) setQualificationMaster(data.Response);

        const CoversModel = {
            InsurerID: 126,
            MasterType: "SPECIALIZATION",
            MasterCode: "doctor"
        };
        const res = await CentralCall("BindMaster_PI", CoversModel);
        if (res.status === 200) setSpecializationList(res.data.Response);
    };

    const CheckCkycStatus = async () => {
        const model = {
            InsurerID: 126,
            MasterType: "CKYCINPUT"
        };
        const { status, data } = await CentralCall("BindMaster_PI", model);
        if (status === 200) setDocTypeList(data.Response);
    };

    useEffect(() => {
        if (props.location?.state) {
            setPrevReq(props.location.state);
            CheckCkycStatus();
            BindQualification();
        }
    }, [props.location?.state]);


    useEffect(() => {
        setFormDetails(prev => ({
            ...prev,
            DOB: new Date(),
            /*  : dob ? dateInYYYYMMDD(dob, "YYYY-MM-DD") : "",*/
            Email: PrevReq?.QuoteReq?.Email,
            MobileNo: PrevReq?.QuoteReq?.MobileNo,
            //Specialization: PrevReq?.QuoteReq?.TypeofSpecializationLabel
        }));
        //console.log(PrevReq, "PrevReq");
        //console.log("DOB from PrevReq:", PrevReq?.QuoteReq?.DOB);
    }, [PrevReq, dob])

    useEffect(() => {
        if (PrevReq?.QuoteReq?.DOB) {
            setDob(new Date(dateInYYYYMMDD(PrevReq.QuoteReq.DOB, "YYYY-MM-DD")))
        }

    }, [PrevReq?.QuoteReq?.DOB])

    const getAge = (dateString) => {
        const birthDate = new Date(dateString);
        if (isNaN(birthDate)) return 0;
        const ageDiff = Date.now() - birthDate.getTime();
        const ageDate = new Date(ageDiff);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    };

    const submitForm = async () => {
        const isValidated = validateForm();
        if (!isValidated) return;
        await callKYC();
    }
    const submitProposal = async (data) => {
        try {
            const year = new Date().getFullYear();
            const ProposalReq = {
                InsurerID: PrevReq?.BuyNow?.InsurerID,
                EnquiryNo: PrevReq?.QuoteReq?.EnquiryNo,
                ProposerName: formDetails.ProposerName,
                ProposerDOB: NewDateToDDMMYYYY(dob),
                PinCode: formDetails.PinCode,
                PANNo: formDetails.PAN,
                EmailID: formDetails.Email,
                MobileNo: formDetails.MobileNo,
                AddressLine1: formDetails.Address1 + formDetails.Address2,
                StateCode: formDetails.StateCode,
                CityCode: formDetails.CityCode,
                Gender: formDetails.Gender,
                ProposerAadhar: "",
                OccupationID: PrevReq?.QuoteReq?.TypeofSpecialization,
                TypeofSpecialization: formDetails.Specialization,
                Experience: formDetails.Experience,
                Qualification: formDetails.Qualification,
                QuoteTransKey: PrevReq?.BuyNow?.TransKey,
                YearOfRegistration: year - parseInt(formDetails.Experience),
                LicenseObtainedYear: year - parseInt(formDetails.Experience),
                KYCDetails: {
                    DocType: KYCDetails?.DocType,
                    DocID: KYCDetails?.DocNumber,
                    KYCTransKey: data?.KycTransKey,
                    CKYCID: data?.CKYCID,
                    CKYCRefID: data?.CKYCRefID
                }
            };

            console.log(ProposalReq, "ProposalReq");
            console.log(KYCDetails, "KYCDetails11");

            const res = await axios.post(`${baseUrl}/central/centralcall/CallReqWithHeader`, {
                URL: "GenerateProposal_PI",
                PostString: JSON.stringify(ProposalReq)
            });

            //setProposalBTNValue("Review and Make Payment");
            setProposalBTNValue("Make Payment");

            if (res.data.StatusCode === 200) {
                const result = await axios.post(`${baseUrl}/central/centralcall/GeneratePGURL`, {
                    Props: [
                        "" + PrevReq?.BuyNow?.InsurerID,
                        res.data.TransKey,
                        PrevReq?.QuoteReq?.EnquiryNo
                    ]
                });

                window.location.href = result.data;
            } else {
                alert(res.data.Message);
            }

        } catch (err) {
            console.error("Proposal submission error:", err);
            alert("Proposal submission failed. Please try again.");
            //setProposalBTNValue("Review and make Payment");
            setProposalBTNValue("Make Payment");
        }
    };

    const validateEmail = (email) => {
        const re = /^\S+@\S+\.\S+$/;
        return re.test(String(email).toLowerCase());
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formDetails.ProposerName || formDetails.ProposerName.trim().length < 3) {
            newErrors.ProposerName = "Please enter a valid name";
        }
        if (!formDetails.PAN) {
            newErrors.PAN = "Invalid PAN format (e.g., ABCDE1234F)";
        }
        if (!formDetails.Experience) {
            newErrors.Experience = "Please select year of experience";
        }
        if (!formDetails.Specialization) {
            newErrors.Specialization = "Please select specialization";
        }
        if (!formDetails.Qualification) {
            newErrors.Qualification = "Please select qualification";
        }
        if (!formDetails.Email || !validateEmail(formDetails.Email)) {
            newErrors.Email = "Invalid email address";
        }
        if (!formDetails.MobileNo || !validateMobileNumber(formDetails.MobileNo)) {
            newErrors.MobileNo = "Invalid mobile number";
        }
        if (!formDetails.Address1) {
            newErrors.Address1 = "Please enter address line 1";
        }
        if (!formDetails.Address2) {
            newErrors.Address2 = "Please enter address line 2";
        }
        if (!formDetails.PinCode || !validatePinCode(formDetails.PinCode)) {
            newErrors.PinCode = "Invalid PIN code";
        }

        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormDetails((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Clear individual field error when input becomes valid
        setError((prevErrors) => {
            const updatedErrors = { ...prevErrors };

            switch (name) {
                case "ProposerName":
                    if (value.trim().length >= 3) delete updatedErrors.ProposerName;
                    break;
                case "PAN":
                    if (value.length === 10) delete updatedErrors.PAN;
                    break;
                case "Experience":
                    if (value) delete updatedErrors.Experience;
                    break;
                case "Specialization":
                    if (value) delete updatedErrors.Specialization;
                    break;
                case "Qualification":
                    if (value) delete updatedErrors.Qualification;
                    break;
                case "Email":
                    if (validateEmail(value)) delete updatedErrors.Email;
                    break;
                case "MobileNo":
                    if (validateMobileNumber(value)) delete updatedErrors.MobileNo;
                    break;
                case "Address1":
                    if (value) delete updatedErrors.Address1;
                    break;
                case "Address2":
                    if (value) delete updatedErrors.Address2;
                    break;
                case "PinCode":
                    if (validatePinCode(value)) delete updatedErrors.PinCode;
                    break;
                default:
                    break;
            }

            return updatedErrors;
        });

        // PIN code-specific logic
        if (name === "PinCode") {
            if (value.length < 6) {
                setFormDetails((prev) => ({
                    ...prev,
                    CityAndState: "",
                }));
            } else if (value.length === 6) {
                getCityAndStateByPinCode(value, name);
            }
        }
    };

    const validatePinCode = (value) => {
        let pinError = "";
        if (!value) {
            pinError = "Please enter pin code.";
        } else if (value.length !== 6 || /^(\d)\1{5}/.test(value)) {
            pinError = "Please enter valid pin code.";
        }
        setError((prev) => ({ ...prev, PinCode: pinError }));
        return pinError === "";
    };
    const validateMobileNumber = (value) => {
        let mobileError = "";
        if (!value) {
            mobileError = "Please enter mobile number.";
        } else if (value.length !== 10) {
            mobileError = "Please enter a 10-digit mobile number.";
        } else if (/^(\d)\1{5}/.test(value.substring(0, 6))) {
            mobileError = "First 6 digits cannot be all the same.";
        }
        setError((prev) => ({ ...prev, MobileNo: mobileError }));
        return mobileError === "";
    };

    const getCityAndStateByPinCode = async (Pin) => {
        try {
            const req = {
                InsurerID: PrevReq?.BuyNow?.InsurerID,
                PinCode: Pin,
            };

            const res = await axios.post(`${baseUrl}/central/centralcall/CallReqWithHeader`, {
                URL: "GetCityStateByPinCode_PI",
                PostString: JSON.stringify(req)
            });

            const cityStateList = res.data?.Response;
            console.log(cityStateList, "GetCityStateByPinCode_PI")
            if (res.data.StatusCode === 200 && cityStateList) {
                setFormDetails((prev) => ({
                    ...prev,
                    CityAndState: `${cityStateList.CityName}, ${cityStateList.StateName}`,
                    CityCode: cityStateList.CityID,
                    StateCode: cityStateList.StateID
                }));
                setCityState(cityStateList);
            } else {
                setError((prev) => ({ ...prev, PinCode: "Invalid PIN code." }));
                setFormDetails((prev) => ({
                    ...prev,
                    CityAndState: "",
                    CityCode: 0,
                    StateCode: 0
                }));
            }
        } catch (error) {
            console.error("PIN code fetch failed:", error);
            setFormDetails((prev) => ({
                ...prev,
                CityAndState: "",
                CityCode: 0,
                StateCode: 0
            }));
        }
    };



    const callKYC = async () => {
        const KYCdetails = {
            EnquiryNo: PrevReq?.QuoteReq?.EnquiryNo,
            TransectionID: "",
            DOB: NewDateToDDMMYYYY(dob),
            Name: formDetails.ProposerName,
            Gender: formDetails.Gender,
            Mobile: formDetails.MobileNo,
            Email: formDetails.Email,
            CompanyID: PrevReq?.BuyNow?.InsurerID,
            PinCode: formDetails.PinCode,
            IsCorporate: false,
            ProductType: 2,
            DocType: KYCDetails?.DocType ?? "PAN",
            DocNumber: KYCDetails?.DocNumber ?? formDetails.PAN,
            Type: 0,
            PolicyType: "0",
            TypeOfPolicy: 1,
            nomineeDetails: {
                Name: "",
                RelationShip: ""
            },
            AddressDetails: {
                PinCode: formDetails.PinCode,
                StateName: cityState.StateName,
                CityName: cityState.CityName,
                AddressLine1: formDetails.Address1,
                AddressLine2: formDetails.Address2,
                AddressLine3: "",
                PerAddressLine1: "",
                PerAddressLine2: "",
                PerAddressLine3: "",
                PerCityName: "",
                PerPinCode: "",
                PerStateName: "",
                IsChangeAddress: ""
            },
            FromHealth: false
        };
        console.log(KYCdetails, "KYCdetails")
        setKYCDetails(KYCdetails);
        setIsKYCCalled(true);
        setProposalBTNValue("wait...");
    };

    const submitKYC = (data) => {
        setKYCDetails(data);
        setIsKYCCalled(false);
        submitProposal(data)

    };

    const formatDateToDDMMYYYY = (date) => {
        console.log({ date })
        if (!date) return "";
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
    console.log(formDetails, "formDetails")
    return (
        <>
            <div className="IndemnityProposalBoxUI ind-Prapos IndemQute">
                {isKYCCalled && <CKYCHome IsProposalKYC={true} KYCDetails={KYCDetails} onKycSubmit={(data) => submitKYC(data)} step={""} CompanyID={126}
                    EnquiryNo={PrevReq?.QuoteReq?.EnquiryNo}
                    CKYCData={DocTypeList} closeKYC={(data) => { setIsKYCCalled(false); setProposalBTNValue("Make Payment"); }} />}
                <div className="container">
                    <div className="row">
                        <div class="col-md-12">
                            <a onClick={() => history.go(-1)} className="arw-btn">
                                <i class="fas fa-long-arrow-alt-left"></i>
                                <span>Back to Quotation</span>
                            </a>
                        </div>
                        
                        <div className="col-md-4">
                            <PropHead Req={PrevReq} />
                        </div>
                        <div className="col-md-8">
                            <div className="IndemnityProposal">
                                <h2 className="IndemnityProposalTitle">Personal Information</h2>
                                <div className="row">
                                    <div className="col-md-16">
                                        <div className="flex SelectGender">
                                            <label className="G-Label">Gender: </label>
                                            <label className="G-Choose">
                                                <input type="radio" name="Gender" value="M" checked={formDetails.Gender === 'M'} onChange={handleChange} />
                                                Male
                                            </label>
                                            <label className="G-Choose">
                                                <input type="radio" name="Gender" value="F" checked={formDetails.Gender === 'F'} onChange={handleChange} />
                                                Female
                                            </label>
                                            {/*<label className="G-Choose">*/}
                                            {/*    <input type="radio" name="Gender" value="O" checked={formDetails.Gender === 'O'} onChange={handleChange} />*/}
                                            {/*    Other*/}
                                            {/*</label>*/}
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="relative">
                                                    <select
                                                        name="Salutation"
                                                        value={formDetails.Salutation}
                                                        onChange={handleChange}
                                                        className="floating-input peer"
                                                    >
                                                        <option value="Dr" selected>Dr.</option>
                                                        <option value="Mr">Mr.</option>
                                                        <option value="Ms">Ms.</option>
                                                        <option value="Mrs">Mrs.</option>
                                                    </select>
                                                    <label className="floating-label">Salutation</label>
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="relative">
                                                    <MaskedInput
                                                        mask={[...Array(40)].map(() => /[a-zA-Z\s]/)}
                                                        guide={false}
                                                        showMask={false}
                                                        type="text"
                                                        name="ProposerName"
                                                        placeholder=" "
                                                        value={formDetails.ProposerName}
                                                        onChange={handleChange}
                                                        className="floating-input peer capitalizeInp"
                                                    />
                                                    <label className="floating-label">Name</label>
                                                    <span className="INDerror">{error["ProposerName"]}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="relative">
                                            <MaskedInput
                                                mask={[/[a-zA-z]/, /[a-zA-z]/, /[a-zA-z]/, /[a-zA-z]/, /[a-zA-z]/, /\d/, /\d/, /\d/, /\d/, /[a-zA-Z]/]}
                                                guide={false}
                                                showMask={false}
                                                type="text"
                                                name="PAN"
                                                placeholder=" "
                                                value={formDetails.PAN}
                                                onChange={handleChange}
                                                className="floating-input peer uppercase"
                                            />
                                            <label className="floating-label">PAN Number</label>
                                            <span className="INDerror">{error["PAN"]}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="relative FloatingDate">
                                            <CustomDatePicker
                                                setDOB={(date) => setDob(date)}
                                                minDate={minDate}
                                                maxDate={maxDate}
                                                RegDate={dob}
                                            />
                                            {dob && (
                                                <small className="UserAge">
                                                    {getAge(dob)} years
                                                </small>
                                            )}
                                            <label className="floating-label">Date of Birth</label>
                                            <span className="INDerror">{error["DOB"]}</span>
                                        </div>
                                    </div>
                                    {/*<div className="form-group">*/}
                                    {/*    <label>Date of Birth</label>*/}
                                    {/*    <CustomDatePicker*/}
                                    {/*        selectedDate={dob}*/}
                                    {/*        onChange={(date) => {*/}
                                    {/*            setDob(date);*/}
                                    {/*            setFormDetails((prev) => ({*/}
                                    {/*                ...prev,*/}
                                    {/*                DOB: date*/}
                                    {/*            }));*/}
                                    {/*        }}*/}
                                    {/*        maxDate={maxDate}*/}
                                    {/*        minDate={minDate}*/}
                                    {/*        placeholder="Select DOB"*/}
                                    {/*    />*/}
                                    {/*    {dob && (*/}
                                    {/*        <div style={{ marginTop: "5px", color: "#333" }}>*/}
                                    {/*            Age: <strong>{getAge(dob)} years</strong>*/}
                                    {/*        </div>*/}
                                    {/*    )}*/}
                                    {/*</div>*/}

                                    <div className="col-md-6">
                                        <div className="relative">
                                            {/*<select*/}
                                            {/*    name="Experience"*/}
                                            {/*    value={formDetails.Experience}*/}
                                            {/*    onChange={handleChange}*/}
                                            {/*    className="floating-input peer"*/}
                                            {/*>*/}
                                            {/*    <option value="">Select Experience</option>*/}
                                            {/*    {[1, 2, 3, 4].map((year) => (*/}
                                            {/*        <option key={year} value={year}>{year} Year{year > 1 ? 's' : ''}</option>*/}
                                            {/*    ))}*/}
                                            {/*</select>*/}
                                            <MaskedInput
                                                className="floating-input peer"
                                                mask={[/[0-9]/, /\d/]}
                                                guide={false}
                                                showMask={false}
                                                type="text"
                                                name="Experience"
                                                value={formDetails.Experience}
                                                onChange={handleChange}
                                                placeholder=" "
                                            />
                                            <label className="floating-label">Year of Experience</label>
                                            <span className="INDerror">{error["Experience"]}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="relative">
                                            <select
                                                name="Specialization"
                                                value={formDetails.Specialization}
                                                onChange={handleChange}
                                                className="floating-input peer"
                                            >
                                                <option disabled value="">Select Specialization</option>
                                                {specializationList?.map((r) => (
                                                    <option key={r.Code} value={r.Code}>{r.Name}</option>
                                                ))}
                                            </select>
                                            <label className="floating-label">Specialization</label>
                                            <span className="INDerror">{error["Specialization"]}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="relative">
                                            <select
                                                name="Qualification"
                                                value={formDetails.Qualification}
                                                onChange={handleChange}
                                                className="floating-input peer"
                                            >
                                                <option disabled value="">Select Qualification</option>
                                                {qualificationMaster?.map((r) => (
                                                    <option key={r.Code} value={r.Code}>{r.Name}</option>
                                                ))}
                                            </select>
                                            <label className="floating-label">Qualification</label>
                                            <span className="INDerror">{error["Qualification"]}</span>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="relative">
                                            <input
                                                type="email"
                                                name="Email"
                                                value={formDetails.Email}
                                                onChange={handleChange}
                                                placeholder=" "
                                                className="floating-input peer"
                                            />
                                            <label className="floating-label">Email Address</label>
                                            <span className="INDerror">{error["Email"]}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="relative">
                                            <MaskedInput
                                                className="floating-input peer"
                                                mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                                guide={false}
                                                showMask={false}
                                                type="text"
                                                name="MobileNo"
                                                value={formDetails.MobileNo}
                                                onChange={handleChange}
                                                placeholder=" "
                                            />
                                            <label className="floating-label">Mobile Number</label>
                                            <span className="INDerror">{error["MobileNo"]}</span>
                                        </div>
                                    </div>
                                </div>

                                <h2 className="IndemnityProposalTitle text-2xl font-semibold mt-10 mb-6">Communication Address</h2>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="Address1"
                                                value={formDetails.Address1}
                                                onChange={handleChange}
                                                className="floating-input peer capitalizeInp"
                                                placeholder=" "
                                            />
                                            <label className="floating-label">Address Line 1</label>
                                            <span className="INDerror">{error["Address1"]}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="Address2"
                                                value={formDetails.Address2}
                                                onChange={handleChange}
                                                className="floating-input peer capitalizeInp"
                                                placeholder=" "
                                            />
                                            <label className="floating-label">Address Line 2</label>
                                            <span className="INDerror">{error["Address2"]}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="relative">
                                            <MaskedInput
                                                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                                guide={false}
                                                showMask={false}
                                                type="text"
                                                name="PinCode"
                                                value={formDetails.PinCode}
                                                onChange={handleChange}
                                                className="floating-input peer"
                                                placeholder=" "
                                            />
                                            <label className="floating-label">PIN Code</label>
                                            <span className="INDerror">{error["PinCode"]}</span>
                                            {(formDetails.CityAndState && formDetails.PinCode.length === 6) && (
                                                <div className="city_state">
                                                    {formDetails.CityAndState}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-10 text-center makePaymentProposalBtn">
                                    <button
                                        type="button"
                                        onClick={() => submitForm()}
                                        className="SMCLarg w-50"
                                    >
                                        {ProposalBTNValue}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}
export default IndemnityProposal;


